import script from "./DashboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardView.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=7839c26d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7839c26d"]])

export default __exports__